import {axios} from ".";
import config from '../config.json';

export const getAllSDG = async () => {
  try{
    const {
      data
    } = await axios.get(`${config.base_url_api}/sdg/`);
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
};


export const getSDGbyID = async(id) => {
  const {
      data
  } = await axios.get(`${config.base_url_api}/sdg/${id}`);
 return data;
};

export const getSDGbyCategoryID = async(id) => {
  const {
      data
  } = await axios.get(`${config.base_url_api}/sdg/category/${id}`);
 return data;
};


